import TicketItem from 'src/Models/TicketItems/Model'
import * as TYPES from '../../types'

export default {
  [TYPES.SET_CURRENT_TICKET_ITEM](state, ticket_item) {
    state.current = new TicketItem(ticket_item)
  },
}
